
import Vue from "vue";
import { mockMobileIntegration } from "./config";

const MOCK_GOVAPP_CONFIG = {
  loginFlag: true,
  tokenReadyFlag: true,
  facialDectectFlag: true,
  tokenResult: {
    accountType: "Personal",
    authToken: "This_is_a_fake_token_only_for_testing",
  },
};

const mockGovApp = {
  closePage() {
    window.alert("this app has been closed");
  },
  isLogin() {
    return MOCK_GOVAPP_CONFIG.loginFlag;
  },
  getAppInfo() { },
  facialDetect({ success, fail }) {
    if (MOCK_GOVAPP_CONFIG.facialDectectFlag) {
      success({ img: "fake facial base64 data" });
    } else {
      fail("facial detect fail");
    }
  },
  getToken({ success, fail }) {
    if (MOCK_GOVAPP_CONFIG.tokenReadyFlag) {
      success(MOCK_GOVAPP_CONFIG.tokenResult);
    } else {
      fail("cannot load token");
    }
  },
};

export function startIntegration(rootElement) {
  console.log('startIntegration')
  if (mockMobileIntegration) {
    Vue.prototype.$govapp = mockGovApp;
  } else if (rootElement.AlipayJSBridge){
    Vue.prototype.$govapp = rootElement.govapp;
  }
  
  if (Vue.prototype.$govapp) {
    console.log('mobile supported!')
  }
}



